import React from "react"
import { Link } from "@inertiajs/react"

/**
 * The copy is resolved server-side by GetSellCtaCopyAction — the question
 * renders as the headline, the call to action inside the button shape. The
 * neutral line is the default so a page that passes no copy (the legacy v1 item
 * templates) still renders a valid banner.
 *
 * The whole banner is the link, not just the red pill — the pill is kept purely
 * as a visual cue. Two motion cues defeat banner-blindness: a hover-lift on the
 * banner, and a slow sheen sweep across the pill. Neither touches the copy, and
 * both are dropped under `prefers-reduced-motion` via `motion-reduce:`.
 */
const NEUTRAL_COPY = {
    headline: "Got guns you're not using?",
    cta: "Get a cash offer.",
}

const WantToSellAGunCTA = ({ copy = null }) => {
    const { headline, cta } = copy?.headline && copy?.cta ? copy : NEUTRAL_COPY

    return (
        <Link
            href="/sell-my-gun"
            className={`
                block w-full min-h-[100px] mt-10 px-6 py-5 rounded-lg z-50
                text-white shadow-lg
                transition-all duration-[180ms] ease-in-out
                hover:-translate-y-1 hover:shadow-2xl
                active:scale-[0.99]
                focus-visible:outline-none focus-visible:ring-2
                focus-visible:ring-white focus-visible:ring-offset-2
                motion-reduce:transition-none
                motion-reduce:hover:translate-y-0
                motion-reduce:active:scale-100
            `}
            style={{
                background: `url('/images/static/Banner-half-FirearmLand.webp') no-repeat center`,
                backgroundSize: "cover",
            }}
        >
            <span
                className="flex h-full flex-col items-center justify-center gap-3 text-center"
                style={{ fontFamily: "Poppins" }}
            >
                <span className="text-[18px] md:text-[20px] font-semibold leading-snug">
                    {headline}
                </span>
                <span className="relative flex max-w-full items-center justify-center overflow-hidden rounded-full bg-[#5E1214] px-5 py-2.5 text-white">
                    <span
                        aria-hidden="true"
                        className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-cta-sheen motion-reduce:hidden"
                    />
                    <span className="relative z-10 text-[14px] md:text-[15px] font-semibold leading-tight">
                        {cta}
                    </span>
                </span>
            </span>
        </Link>
    )
}

export default WantToSellAGunCTA
